"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntime = void 0;
var tslib_1 = require("tslib");
var IHaier2_1 = tslib_1.__importDefault(require("./IHaier2"));
var IHaierDebug_1 = tslib_1.__importDefault(require("./IHaierDebug"));
var IHaierIFrameRuntime_1 = tslib_1.__importDefault(require("../iframe/IHaierIFrameRuntime"));
var IframeMessage_1 = require("../iframe/IframeMessage");
var chivy_1 = tslib_1.__importDefault(require("chivy"));
var c = new chivy_1.default("iHaier2.0 sdk 初始化");
function getRuntime(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var ihaier2, appId, appSecret, authUrl, err_1, debug;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof options !== "object") {
                        options = {
                            appId: "cli_a12367272bb9900e",
                            appSecret: "-1",
                            authUrl: "http://127.0.0.1:3025/ihaier-runtime-auth-server"
                        };
                    }
                    if (typeof options.authUrl !== "string") {
                        options.authUrl = "http://" + window.location.hostname + ":3025/ihaier-runtime-auth-server";
                    }
                    if (typeof options.appId !== "string") {
                        options.appId = "cli_a12367272bb9900e";
                    }
                    if (typeof options.appSecret !== "string") {
                        options.appSecret = "-1";
                    }
                    if (!(navigator.userAgent.includes("Lark") && navigator.userAgent.includes("LarkLocale"))) return [3 /*break*/, 5];
                    //判断是否是在iframe里面
                    if (window.top != window.self) {
                        return [2 /*return*/, new IHaierIFrameRuntime_1.default()];
                    }
                    ihaier2 = new IHaier2_1.default();
                    //监听iframe里传过来的事件方法
                    IframeMessage_1.messageListener(ihaier2);
                    if (options.noAuth === true)
                        return [2 /*return*/, ihaier2];
                    appId = options.appId;
                    appSecret = options.appSecret;
                    authUrl = options.authUrl;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ihaier2.initialize("https://r.haier.net/assets/hgit.haier.net/overlay/dts-fe/common-assets/ihaier-sdk/1.5.18/js-sdk.js", appId, appSecret, authUrl)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    c.error(err_1);
                    return [2 /*return*/, undefined];
                case 4: 
                //父级容器添加iframe事件兼听
                return [2 /*return*/, ihaier2];
                case 5:
                    debug = new IHaierDebug_1.default();
                    return [4 /*yield*/, debug.initialize()];
                case 6:
                    _a.sent();
                    return [2 /*return*/, debug];
            }
        });
    });
}
exports.getRuntime = getRuntime;
//# sourceMappingURL=data:application/json;base64,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